module.exports = __webpack_public_path__ + "img/slack-icon.ceaf12e2.svg";